module.exports = __webpack_public_path__ + "static/media/cliente-domestica.59042a7f.svg";